import cookies from 'js-cookie';
import { StoreCode } from 'schema/storeCode';

export const STORE_OVERRIDE_PARAM = 'store';
export const COOKIE_STORE_KEY = 'ag-store';
export const COOKIE_STORE_MAX_AGE_DAYS = 2;

export function setAgStore(value: StoreCode) {
  cookies.set(COOKIE_STORE_KEY, value, {
    path: '/',
    expires: COOKIE_STORE_MAX_AGE_DAYS,
    sameSite: 'lax'
  });
}
